import React from "react";
import Batch from "../Batch";

const SummaryBatches = () => {
    return <Batch status="summary" title="Summary" />;
};

export default SummaryBatches;
